/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_CreditInputs */

const vi_error_payment_method_change_credit = /** @type {(inputs: Error_Payment_Method_Change_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản này là cấn số dư trả trước của khách, không phải tiền thu mới, nên không đổi hình thức được.`)
};

/**

* @param {Error_Payment_Method_Change_CreditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_credit = /** @type {((inputs?: Error_Payment_Method_Change_CreditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_CreditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_credit(inputs)
});